import Vue from "vue";
Vue.filter("numberRound", (value) => {
  if (value !== undefined) {
    if (!isNaN(parseFloat(value)) && isFinite(value)) {
      return parseFloat(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
      });
    } else {
      return value;
    }
  }
});
